import NextImage from "next/image";
import type { ComponentProps } from "react";
import { isSvgUrl } from "@/app/[lang]/utils/api-helpers";

type SmartImageProps = ComponentProps<typeof NextImage>;

/**
 * Drop-in replacement for next/image that renders SVG sources with `unoptimized`,
 * so SVGs bypass the image optimizer (which rejects them unless dangerouslyAllowSVG
 * is honored at runtime). Raster images keep full optimization. An explicit
 * `unoptimized` prop always wins.
 */
export default function SmartImage(props: SmartImageProps) {
    const { src } = props;
    const url = typeof src === "string" ? src : (src as { src?: string })?.src;
    const unoptimized = props.unoptimized ?? isSvgUrl(url);

    return <NextImage {...props} unoptimized={unoptimized} />;
}
